import React from 'react';

const IconLongArrowLeft = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 20 20"
  >
    <defs>
      <path
        id="prefix__a1312312"
        d="M12.5 5.833H3.192l4.066-4.066c.325-.325.325-.859 0-1.184-.325-.325-.85-.325-1.175 0L.592 6.075c-.325.325-.325.85 0 1.175l5.491 5.492c.325.325.85.325 1.175 0 .325-.325.325-.85 0-1.175L3.192 7.5H12.5c.458 0 .833-.375.833-.833 0-.459-.375-.834-.833-.834z"
      />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path d="M0 0L20 0 20 20 0 20z" />
      <g transform="translate(3.333 3.333)">
        <mask
          id="prefix__b321312312"
          fill="#fff"
        >
          <use xlinkHref="#prefix__a1312312" />
        </mask>
        <g
          fill={color}
          mask="url(#prefix__b321312312)"
        >
          <path
            d="M0 0H20V20H0z"
            transform="translate(-3.333 -3.333)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLongArrowLeft;
